export default "__VITE_ASSET__BxUmKcUn__"